// extracted by mini-css-extract-plugin
export default {"subtitle":"mt8w8D","noBottomMargin":"aKK9QY"};